export abstract class AcheivementDef {
  color?: string;
  name: string = "";
  list_terms: string[] = [];
  resource_id: string = "";
  resource_uri?: string;
}
